import { render, staticRenderFns } from "./AccessesTree.vue?vue&type=template&id=482aa5e2&scoped=true&"
import script from "./AccessesTree.vue?vue&type=script&lang=ts&"
export * from "./AccessesTree.vue?vue&type=script&lang=ts&"
import style0 from "./AccessesTree.vue?vue&type=style&index=0&id=482aa5e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482aa5e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCheckbox,VTreeview})
